import React from 'react'
import { RenderControl } from '@fareye/ui'
import {
  isEmpty,
  cancelToken,
  post,
  responseParser,
  groupBy,
  flatten
} from '@fareye/utils'
import { zonedToUTC, zonedToUTCAdd1Day, useTranslation } from '@fareye/common'
import { mapping } from '../../../config/mapComponents'
import { RouteContainerGrid } from '../../../style/styled'
import { cloneDeep } from '@fareye/utils'
const MultiModalRoute = ({
  match,
  config,
  history,
  endDate,
  location,
  startDate,
  globalSearch,
  setTransportModeFilter,
  setSummaryData,
  selectedMode,
  summaryFilter
}: any) => {
  const source = cancelToken().source()
  const {
    config: { apiConfig },
    styling,
    children
  } = config
  const { t } = useTranslation()
  const { style, className } = styling
  const compName: any = (children as any).component
  const Component = children && (mapping as any)[compName]
  const [apiResponse, setApiResponse] = React.useState<any>({
    data: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
  })
  function generateFilterDataFromGlobalSearch(globalSearch: any[]) {
    if (isEmpty(globalSearch)) {
      return []
    } else {
      const groupedSearch = groupBy(globalSearch, ele => ele.key)
      return Object.entries(groupedSearch).map(([key, value]) => {
        return [
          {
            filterKey: key,
            filterValue: value.reduce((res = [], obj) => {
              res.push(obj.value)
              return res
            }, []),
            condition: 'include',
            filterType: 'eq'
          }
        ]
      })
    }
  }
  function generateFilterObjectForDateRange(startDate: any, endDate: any) {
    const startFilter = [
      {
        filterKey: 'start_date',
        filterValue: startDate ? zonedToUTC(startDate) : new Date(),
        condition: 'include',
        filterType: 'gte'
      }
    ]
    const endFilter = [
      {
        filterKey: 'start_date',
        filterValue: endDate ? zonedToUTCAdd1Day(endDate) : new Date(),
        condition: 'include',
        filterType: 'lt'
      }
    ]

    const deliveredFilter = [
      {
        filterKey: 'milestone_carrier_status',
        filterValue: 'DELIVERED',
        condition: 'include',
        filterType: 'eq'
      }
    ]
    return [startFilter, endFilter, deliveredFilter]
  }

  function generateFilterDataFromAggregation() {
    let aggsType: any[] = []
    if (!isEmpty(summaryFilter?.key)) {
      let diffAggs = Object.keys(summaryFilter.key)
      diffAggs.forEach((key: string) => {
        aggsType.push({
          filterKey: key,
          filterValue: summaryFilter.key[key],
          condition: 'include',
          filterType: 'eq'
        })
      })
    }
    return aggsType ? aggsType : []
  }

  async function fetchData() {
    try {
      const { apiURL, queryParams } = apiConfig
      setApiResponse({ ...apiResponse, isLoading: true })
      setSummaryData([])
      let filter = generateFilterDataFromGlobalSearch(globalSearch)
      const dateFilter = generateFilterObjectForDateRange(startDate, endDate)
      const aggsFilter = generateFilterDataFromAggregation()
      filter = [...filter, ...dateFilter, ...[aggsFilter]]
      const {
        data: { content, contentSummary, transportModeSummary },
        message,
        error
      } = responseParser(
        await post(
          `${apiURL}`,
          {
            filter,
            perPage: 10000,
            page: 1,
            ...queryParams,
            aggs: ['status']
          },
          source.token,
          {
            headers: { 'Key-Inflection': 'camel', 'X-Change-Case': true }
          }
        )
      )

      setTransportModeFilter(transportModeSummary)
      setSummaryData(contentSummary ? contentSummary : [])
      setApiResponse({
        ...apiResponse,
        isError: error,
        data: error ? content : content ? content : [], // FIXME: Weird should be []
        isSuccess: true,
        isLoading: false,
        message: error
          ? message
          : isEmpty(content)
          ? apiConfig && apiConfig.apiDataState
            ? apiConfig.apiDataState.noDataMessage
            : 'No Data Found'
          : ''
      })
    } catch (err:any) {
      const { message, error } = responseParser(err.response)
      setApiResponse({
        ...apiResponse,
        isSuccess: false,
        isError: true,
        isLoading: false,
        message
      })
      console.error('App Error:', error)
    }
  }

  React.useEffect(() => {
    fetchData()
    return () => {
      source.cancel('Unsubscribe Before Unmount')
    }
    // eslint-disable-line
  }, [globalSearch, startDate, endDate, summaryFilter])

  const { data } = apiResponse
  const transporterData = !isEmpty(data) ? flatten(data) : []
  // using cloneDeep because using "=" operator makes a referenced object instead of a copy
  // using wrapper on copied/referenced object also mutates the original object, hence used cloneDeep
  // Impact --- changing selected language repeatedly wont result in text stuck at 1 language
  let translatedApiResponse = cloneDeep(apiResponse)
  translatedApiResponse.message = t(translatedApiResponse.message)
  return (
    <RenderControl state={translatedApiResponse} variant={'l'} t={t}>
      {/* move padding to config */}
      <RouteContainerGrid
        style={{ ...style, padding: '2vw 1vw' }}
        className={className}
      >
        {transporterData
          .sort((a: any, b: any) => {
            return a.totalTrips > b.totalTrips ? -1 : 1
          })
          .map((item: any, index: number) => (
            <Component
              {...item}
              match={match}
              history={history}
              endDate={endDate}
              location={location}
              startDate={startDate}
              key={`TransportersDetailsCard${index}`}
              config={config.children}
            />
          ))}
      </RouteContainerGrid>
    </RenderControl>
  )
}

export default MultiModalRoute
